const imageModules = import.meta.glob("../assets/images/**/*", {
  eager: true,
  import: "default",
}) as Record<string, string>;

const trimSlashes = (value: string): string => {
  let start = 0;
  let end = value.length;

  while (start < end && value[start] === "/") {
    start += 1;
  }

  while (end > start && value[end - 1] === "/") {
    end -= 1;
  }

  return value.slice(start, end);
};

const getCurrentSearch = (): string => {
  if (typeof window === "undefined") {
    return "";
  }

  return window.location.search;
};

export const loadLocalImage = (
  image: string,
  folder = "",
  fallback = ""
): string => {
  const normalizedFolder = trimSlashes(folder);

  const path = normalizedFolder
    ? `../assets/images/${normalizedFolder}/${image}`
    : `../assets/images/${image}`;

  const imageUrl = imageModules[path];

  if (!imageUrl && import.meta.env.DEV) {
    console.warn(`Imagem não encontrada: ${path}`);
  }

  return imageUrl ?? fallback;
};

export const getQueryUrlParam = (
  param: string,
  search?: string
): string | null => {
  const queryParams = new URLSearchParams(search ?? getCurrentSearch());

  return queryParams.get(param);
};

export const normalizePhoneDigits = (phone?: string | null): string => {
  if (!phone) return "";

  let digits = "";

  for (const char of phone) {
    if (char >= "0" && char <= "9") {
      digits += char;
    }
  }

  return digits;
};

const removeCountryCode = (digits: string): string => {
  if (digits.startsWith("55") && digits.length >= 12) {
    return digits.slice(2);
  }

  return digits;
};

export const extractDDD = (phone?: string | null): string | null => {
  const digits = removeCountryCode(normalizePhoneDigits(phone));

  if (digits.length < 10) {
    return null;
  }

  return digits.slice(0, 2);
};

export const onlyPhoneNumber = (phone?: string | null): string | null => {
  const digits = removeCountryCode(normalizePhoneDigits(phone));

  if (digits.length < 10) {
    return null;
  }

  return digits.slice(2);
};